import React, { useEffect, useState } from "react";
import Button from "../Button/Button";
import "./ProductModal.css";
import { useLanguage } from "../../../context/LanguageContext";

interface ProductLike {
  id: string;
  name: string;
  description?: string | null;
  category?: string | null;
  image_url?: string | null;
  gallery?: string[] | null;
  created_at?: string | null;
}

interface ProductModalProps {
  product?: ProductLike | null;
  isOpen: boolean;
  onClose: () => void;
}

const ProductModal: React.FC<ProductModalProps> = ({ product, isOpen, onClose }) => {
  const [fullOpen, setFullOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const { t } = useLanguage();
  let images: string[] = [];
  let current: string | null = null;
  useEffect(() => {
    return () => { document.body.style.overflow = 'unset'; };
  }, [isOpen]);

  if (!isOpen || !product) return null;

  const baseGallery = Array.isArray(product.gallery) ? product.gallery as string[] : [];
  images = baseGallery.length > 0 ? baseGallery : (product.image_url ? [product.image_url] : []);
  current = images[index] || null;

  
  const handleWhatsApp = () => {
    const phone = '+905346690042'.replace(/\s+/g, '').replace('+', '');
    const msg = encodeURIComponent(t('whatsapp.messageWithProduct').replace('{product}', product.name));
    const url = `https://wa.me/${phone}?text=${msg}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const handleShare = async () => {
    const text = `${product.name}${product.category ? ' - ' + product.category : ''}`;
    const url = window.location.origin + '/products';
    if ((navigator as any).share) {
      try {
        await (navigator as any).share({ title: product.name, text, url });
      } catch {}
    } else {
      try {
        await navigator.clipboard.writeText(`${text} \n${url}`);
        alert(t('ui.copyLinkSuccess'));
      } catch {}
    }
  };

  return (
    <div className="product-modal" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="product-modal__content" onClick={(e) => e.stopPropagation()}>
        <button className="product-modal__close" aria-label={t('common.close')} onClick={onClose}>×</button>
        <div className="product-modal__grid">
          <div className="product-modal__image" onClick={() => setFullOpen(!!current)}>
            {current ? (
              <img src={current} alt={product.name} className="product-modal__image-inner" decoding="async" />
            ) : (
              <div className="product-modal__placeholder" />
            )}
          </div>
          <div className="product-modal__details">
            <h3 className="product-modal__title">{product.name}</h3>
            {product.category && (
              <p className="product-modal__category">{product.category}</p>
            )}
            
            {product.description && (
              <p className="product-modal__desc">{product.description}</p>
            )}
            <div className="product-modal__actions">
              <Button variant="primary" size="md" onClick={handleWhatsApp} leftIcon={<i className="fab fa-whatsapp"></i>}>
                {t('product.modal.whatsapp.cta')}
              </Button>
              <Button variant="outline" size="md" onClick={handleShare} rightIcon={<i className="fas fa-share-alt"></i>}>
                {t('product.modal.share')}
              </Button>
            </div>
            {images.length > 1 && (
              <div className="product-modal__thumbs">
                <button className="thumbs__nav" onClick={() => setIndex((index - 1 + images.length) % images.length)} aria-label={t('common.previous')}>‹</button>
                <div className="thumbs__list">
                  {images.map((src, i) => (
                    <img key={i} src={src} className={`thumbs__item ${i === index ? 'thumbs__item--active' : ''}`} onClick={() => setIndex(i)} alt="" loading="lazy" decoding="async" />
                  ))}
                </div>
                <button className="thumbs__nav" onClick={() => setIndex((index + 1) % images.length)} aria-label={t('common.next')}>›</button>
              </div>
            )}
          </div>
        </div>
      </div>
      {fullOpen && current && (
        <div className="product-modal__full" onClick={() => setFullOpen(false)}>
          <div className="product-modal__full-content" onClick={(e) => e.stopPropagation()}>
            <button className="product-modal__full-close" aria-label={t('common.close')} onClick={() => setFullOpen(false)}>×</button>
            <img src={current} alt={product.name} className="product-modal__full-img" decoding="async" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductModal;
